<template>
  <div class="condition-item">
    <el-select
      v-model="val"
      :id="'label_' + id"
      @change="inputChange"
      class="condition-input input-normal"
      :placeholder="placeholder"
      size="small"
    >
      <slot></slot>
    </el-select>
    <!-- <el-input
      v-model="val"
      :id="'label_' + id"
      @input="inputChange"
      class="condition-input input-normal"
      :placeholder="placeholder"
      size="small"
    ></el-input> -->
    <div v-if="id" :ref="'label_' + id" class="condition-item-label">
      {{ label }}
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      id: "",
      labelWidth: 0,
      val: "",
    };
  },
  model: {
    prop: "value",
    event: "input",
  },
  props: {
    value: [String, Number],
    label: {
      type: String,
      default: "",
    },
    placeholder: {
      type: String,
      default: "",
    },
  },
  mounted() {
    this.val = this.value;
    this.id = this.$rrj.uuid();
    this.$nextTick(() => {
      this.labelWidth = this.$refs["label_" + this.id].offsetWidth;
      document.getElementById("label_" + this.id).style.paddingLeft =
        this.labelWidth + 10 + "px";
    });
  },
  methods: {
    inputChange() {
      this.$emit("input", this.val);
    },
  },
};
</script>

<style lang="scss"></style>
